export const SITE_DICTIONARY_TYPE_VALUE = {
  PROJECT_WORKFLOW: 'PROJECTWORKFLOW',
  RULE_CATEGORY: 'RULECATEGORY',
  STATEMENT_STATUS: 'STATEMENTSTATUS',
};
